import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeclarationAccessibiliteComponent } from './declaration-accessibilite/declaration-accessibilite.component';

const routes: Routes = [

    {
        path: '',
        redirectTo: 'catalogue',
        pathMatch: 'full'
    },
    {
        path: 'catalogue',
        loadChildren: () => import('./catalog/catalog-routing.module').then(m => m.CatalogRoutingModule)
    },
    {
        path: 'cartographie',
        loadChildren: () => import('./cartographie/cartographie-routing.module').then(m => m.CartographieRoutingModule)
    },
    {
        path: 'declaration',
        component: DeclarationAccessibiliteComponent
    }

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})


export class AppRoutingModule {
}
